module.exports = __webpack_public_path__ + "img/09.4aeadd76.png";